import { ThemeProvider } from "@material-ui/core";
import { PrimaryColor } from "@resource/common";
import OrganizationThemeWrapper from "components/OrganizationThemeWrapper";
import StageStepper from "components/Preview/StageStepper";
import _ from "lodash";
import { FunctionComponent } from "react";
import { resourceRed, themeCreator } from "styles/config";

type SimpleStage = {
  position: number;
  name: string;
  description?: string;
};

type InterviewProcessProps = {
  stages: SimpleStage[];
  theme?: {
    primaryColor: string;
    secondaryColor?: string | null;
  };
};

const InterviewProcess: FunctionComponent<InterviewProcessProps> = ({
  stages,
  theme: { primaryColor, secondaryColor } = {
    primaryColor: PrimaryColor,
    secondaryColor: PrimaryColor,
  },
}) => {
  const sortedStages = _(stages)
    .map((stage) => ({
      ...stage,
      __typename: "Stage" as const,
      id: `${stage.position}`,
      title: stage.name,
      description: stage.description || null,
      hidden: false,
      needsFeedback: false,
    }))
    .sortBy("position")
    .value();

  const orgPrimaryColor = primaryColor !== "#ffffff" ? primaryColor : "#79728C";
  const orgSecondaryColor =
    secondaryColor && secondaryColor !== "#ffffff"
      ? secondaryColor
      : resourceRed;

  return sortedStages.length > 0 ? (
    <ThemeProvider
      theme={themeCreator({
        primaryColorHex: orgPrimaryColor,
        secondaryColorHex: orgSecondaryColor,
      })}
    >
      <OrganizationThemeWrapper
        theme={{
          primaryColor: orgPrimaryColor,
          secondaryColor: orgSecondaryColor,
        }}
      >
        <StageStepper
          stages={sortedStages}
          currentStageId={sortedStages[0].id}
          selectedStageId={sortedStages[0].id}
          onSelectStageId={() => {}}
        />
      </OrganizationThemeWrapper>
    </ThemeProvider>
  ) : null;
};

export default InterviewProcess;
